(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTrack(track) {
      if (track.__pvBound) return;
      track.__pvBound = true;

      const updateDraggable = () => {
        track.classList.toggle('is-draggable', track.scrollWidth - track.clientWidth > 1);
      };
      updateDraggable();
      window.addEventListener('resize', updateDraggable);
      if ('ResizeObserver' in window) new ResizeObserver(updateDraggable).observe(track);

      // Pointer-driven drag with momentum (mouse + pen). Touch keeps native scrolling.
      let isDown = false;
      let pointerType = 'mouse';
      let startX = 0;
      let lastX = 0;
      let lastTime = 0;
      let velocity = 0;
      let momentumId = null;
      let movedDistance = 0;
      let originalSnap = '';

      const cancelMomentum = () => {
        if (momentumId) cancelAnimationFrame(momentumId);
        momentumId = null;
      };

      const runMomentum = () => {
        if (Math.abs(velocity) < 0.04) {
          track.style.scrollSnapType = originalSnap || '';
          momentumId = null;
          return;
        }
        track.scrollLeft -= velocity * 16;
        velocity *= 0.94;
        momentumId = requestAnimationFrame(runMomentum);
      };

      track.addEventListener('pointerdown', (e) => {
        if (!track.classList.contains('is-draggable')) return;
        // Don't hijack the gesture when it starts on an interactive child —
        // setPointerCapture would redirect the resulting `click` to the track
        // and our document-level play/close delegation would never see the
        // real target.
        if (e.target.closest('button, a, [role="button"], input, select, textarea, label')) return;
        pointerType = e.pointerType || 'mouse';
        if (pointerType === 'touch') return; // let native momentum handle touch
        if (pointerType === 'mouse' && e.button !== 0) return;
        cancelMomentum();
        isDown = true;
        startX = e.clientX;
        lastX = e.clientX;
        lastTime = performance.now();
        velocity = 0;
        movedDistance = 0;
        originalSnap = getComputedStyle(track).scrollSnapType;
        track.style.scrollSnapType = 'none';
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });

      track.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const now = performance.now();
        const dx = e.clientX - lastX;
        const dt = Math.max(1, now - lastTime);
        velocity = velocity * 0.6 + (dx / dt) * 0.4;
        track.scrollLeft -= dx;
        lastX = e.clientX;
        lastTime = now;
        movedDistance = Math.abs(e.clientX - startX);
        if (movedDistance > 4) track.classList.add('is-dragging');
      });

      const end = (e) => {
        if (!isDown) return;
        isDown = false;
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        setTimeout(() => track.classList.remove('is-dragging'), 60);
        if (Math.abs(velocity) > 0.05) momentumId = requestAnimationFrame(runMomentum);
        else track.style.scrollSnapType = originalSnap || '';
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('pointerleave', end);

      // Suppress accidental clicks ONLY if we actually entered drag mode
      track.addEventListener('click', (e) => {
        if (track.classList.contains('is-dragging')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    function closeDialog(dialog) {
      const v = dialog.querySelector('video');
      if (v) { try { v.pause(); } catch (err) {} }
      try { dialog.close(); } catch (err) {}
      dialog.removeAttribute('open');
      dialog.classList.remove('is-open');
      document.documentElement.classList.remove('pv-no-scroll');
    }

    function openVideoDialog(dialog) {
      // Portal to <body> on first open so overflow:hidden / transformed ancestors
      // can't suppress the modal.
      if (dialog.parentElement !== document.body) {
        document.body.appendChild(dialog);
      }
      // Make sure stale state from a previous fallback doesn't break showModal()
      if (dialog.hasAttribute('open')) {
        try { dialog.close(); } catch (err) {}
        dialog.removeAttribute('open');
      }
      let opened = false;
      try {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
          opened = true;
        }
      } catch (err) {}
      if (!opened) {
        dialog.setAttribute('open', '');
        dialog.classList.add('is-open');
        document.documentElement.classList.add('pv-no-scroll');
      }
      const video = dialog.querySelector('video');
      if (video) {
        try { video.currentTime = 0; } catch (err) {}
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }
    }

    // Event delegation — works no matter when buttons/dialogs appear in the DOM
    if (!window.__pvCommunityDelegated) {
      window.__pvCommunityDelegated = true;

      document.addEventListener('click', (e) => {
        const playBtn = e.target.closest('[data-pv-play]');
        if (playBtn) {
          e.preventDefault();
          const id = playBtn.getAttribute('data-pv-dialog');
          const dialog = id && document.getElementById(id);
          if (dialog) openVideoDialog(dialog);
          return;
        }

        const closeBtn = e.target.closest('[data-pv-dialog-close]');
        if (closeBtn) {
          const dialog = closeBtn.closest('dialog');
          if (dialog) closeDialog(dialog);
          return;
        }

        // Click on backdrop area of an open video dialog → close
        if (e.target.matches && e.target.matches('dialog[data-pv-video-dialog]')) {
          closeDialog(e.target);
        }
      });

      document.addEventListener('close', (e) => {
        if (e.target.matches && e.target.matches('dialog[data-pv-video-dialog]')) {
          const v = e.target.querySelector('video');
          if (v) { try { v.pause(); } catch (err) {} }
        }
      }, true);
    }

    function init(root) {
      (root || document).querySelectorAll('[data-pv-community-track]').forEach(initTrack);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (!section || section.__pvFpReady) return;
      section.__pvFpReady = true;

      const tabs = section.querySelectorAll('[data-pv-tab]');
      const panels = section.querySelectorAll('[data-pv-panel]');
      const viewAll = section.querySelector('[data-pv-view-all]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const idx = tab.getAttribute('data-pv-tab');
          tabs.forEach(function (t) {
            const active = t.getAttribute('data-pv-tab') === idx;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            const active = p.getAttribute('data-pv-panel') === idx;
            p.classList.toggle('is-active', active);
            if (active) {
              p.removeAttribute('hidden');
              if (viewAll) {
                const url = p.getAttribute('data-pv-collection-url');
                if (url) viewAll.setAttribute('href', url);
              }
            } else {
              p.setAttribute('hidden', '');
            }
          });
        });
      });

      // Slider arrows per panel
      section.querySelectorAll('[data-pv-slider]').forEach(function (slider) {
        const track = slider.querySelector('[data-pv-track]');
        const prev = slider.querySelector('[data-pv-prev]');
        const next = slider.querySelector('[data-pv-next]');
        if (!track || !prev || !next) return;

        function step() {
          const first = track.firstElementChild;
          if (!first) return track.clientWidth;
          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap || '0');
          return first.getBoundingClientRect().width + gap;
        }

        function updateArrows() {
          const max = track.scrollWidth - track.clientWidth - 2;
          prev.toggleAttribute('disabled', track.scrollLeft <= 2);
          next.toggleAttribute('disabled', track.scrollLeft >= max);
        }

        prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();

        // Always let vertical wheel scroll the page, never the track.
        // Convert horizontal wheel intent to track scroll.
        track.addEventListener('wheel', function (e) {
          const absX = Math.abs(e.deltaX);
          const absY = Math.abs(e.deltaY);
          if (absY > absX) return; // vertical → bubble to page
          // horizontal → consume and scroll the track
          e.preventDefault();
          track.scrollLeft += e.deltaX;
        }, { passive: false });

        // Mouse drag-to-scroll (desktop). We only capture the pointer once a
        // real drag is detected, so a plain click still fires on the card link.
        let dragState = null;
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          if (e.button !== 0) return;
          dragState = {
            startX: e.clientX,
            startScroll: track.scrollLeft,
            moved: false,
            id: e.pointerId,
            captured: false,
          };
        });
        track.addEventListener('pointermove', function (e) {
          if (!dragState || e.pointerId !== dragState.id) return;
          const dx = e.clientX - dragState.startX;
          if (!dragState.moved && Math.abs(dx) > 5) {
            dragState.moved = true;
            track.classList.add('is-dragging');
            try { track.setPointerCapture(dragState.id); dragState.captured = true; } catch (_) {}
          }
          if (dragState.moved) {
            track.scrollLeft = dragState.startScroll - dx;
          }
        });
        function endDrag(e) {
          if (!dragState || (e && e.pointerId !== dragState.id)) return;
          const moved = dragState.moved;
          if (dragState.captured) {
            try { track.releasePointerCapture(dragState.id); } catch (_) {}
          }
          dragState = null;
          if (moved) {
            // Suppress the click that follows pointerup after a real drag
            track.addEventListener('click', function suppress(ev) {
              ev.preventDefault();
              ev.stopPropagation();
              track.removeEventListener('click', suppress, true);
            }, true);
          }
          requestAnimationFrame(function () { track.classList.remove('is-dragging'); });
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
      });
    }

    document.querySelectorAll('[data-pv-fp]').forEach(initSection);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        const s = e.target.querySelector('[data-pv-fp]');
        if (s) initSection(s);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
